import urlJoin from "url-join";

export function subUrl(base: string | URL | undefined, part: string): string {
    const url = new URL(base ?? window.location.href, window.location.href);
    return urlJoin(url.pathname, part);
}
